import React from "react";
import { TextField, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import FieldLabel from "./FieldLabel";

const useStyles = makeStyles()(() => ({
	hint: {
		fontSize: "12px",
		color: "#6b7280",
		marginTop: "4px",
	},
}));

const DeliveryEmailField = ({ value, onChange, fallbackEmail }) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return (
		<div>
			<FieldLabel>{t("label.deliveryEmail")}</FieldLabel>
			<TextField
				name="deliveryEmail"
				variant="outlined"
				fullWidth
				value={value || ""}
				placeholder={fallbackEmail || ""}
				onChange={(e) => onChange(e.target.value)}
			/>
			<Typography className={classes.hint}>
				{t("message.onlyOneEmailSupported")}
				{fallbackEmail ? ` ${t("message.leaveBlankUseProfileEmail")}` : ""}
			</Typography>
		</div>
	);
};

export default DeliveryEmailField;
